module.exports = __webpack_public_path__ + "static/media/S (187).61d6135d.jpg";